import { Language } from "../const";
import { CATEGORIES, type MEDIA_TYPE, type PublicationType } from "../../const";

export const pamphletListLanguageMap: Record<Language, string> = {
  [Language.EN]: "/data/en/pub/pamphlets-en.json",
  [Language.TC]: "/data/tc/pub/pamphlets-tc.json",
  [Language.SC]: "/data/sc/pub/pamphlets-sc.json",
};
export function getPamphletData(pamphlet_json: any[]): {
  pamphletsList: PublicationType[];
  bookletsList: PublicationType[];
} {
  const pamphletsList: PublicationType[] = pamphlet_json
    ?.filter((items) => items.cate === "PAMPHLET")
    .map((item) => ({
      title: item?.title ?? "",
      date: item?.date ?? "",
      link: item?.url ?? "",
      mediaType: item?.type as MEDIA_TYPE, // PDF
      thumbnail: item?.thumb ?? "",
      category: [CATEGORIES.PUBLICATIONS],
    }));

  const bookletsList: PublicationType[] = pamphlet_json
    .filter((items) => items.cate === "BOOKLET")
    .map((item) => ({
      title: item?.title ?? "",
      date: item?.date ?? "",
      link: item?.url ?? "",
      mediaType: item?.type as MEDIA_TYPE, // PDF
      thumbnail: item?.thumb ?? "",
      category: [CATEGORIES.PUBLICATIONS],
    }));
  return { pamphletsList, bookletsList };
}
